module.exports = __webpack_public_path__ + "img/about.af41ba62.png";